/* ================================================== */
/* FUNCTIONS
/* ================================================== */

// Init
var breakpoint_xs;
var sessionStorageSupport = false;


// Check breakpoints
$(window).resize(function(){
	breakpoint_xs = $(window).width() <= 767;
}).resize();


// Check sessionStorage
function checkSessionStorageSupport() {
	var testKey = 'test',
		storage = window.sessionStorage;
	try {
		storage.setItem(testKey, '1');
		storage.removeItem(testKey);
		sessionStorageSupport = true;
	} catch(e) {
		return false;
	}
}


// Check if iOS (fix VH issues)
function checkIos() {
	var iDevices = [
		'iPad Simulator',
		'iPhone Simulator',
		'iPod Simulator',
		'iPad',
		'iPhone',
		'iPod'
	];

	while (iDevices.length) {
		if (navigator.platform === iDevices.pop()) {
			if (!$('body').hasClass('device--ios')) {
				$('body').addClass('device--ios');
			}

			iosFallback();
		}
	}

	return false;
}


// iOS fallback
function iosFallback() {
	if (breakpoint_xs) {
		$('#layout--main').css('min-height', 'calc('+$(window).innerHeight()+' - 27.46314rem)'+'px');
		$('.homepage #layout--main').css('height', 'calc('+$(window).innerHeight()+' - 27.46314rem)'+'px');
	} else {
		$('#layout--main').css('min-height', 'calc('+$(window).innerHeight()+' - 22.42857rem)'+'px');
		$('.homepage #layout--main').css('height', 'calc('+$(window).innerHeight()+' - 22.42857rem)'+'px');
	}

	$('.overlay--picture .overlay__container').css('width',($(window).innerHeight()*0.8)+'px');
	$('.section--header, .overlay--picture, .section--main__gallery').css('background-attachment','scroll');
}


// Fluid embeds
$(function() {
	var $fluidElements = $('.embeds .embed');
	
	$fluidElements.each(function(){
		var $figure = $(this);
		var $objs   = $figure.find('iframe[src^="http://player.vimeo.com"], iframe[src^="http://www.youtube.com"], object, embed, iframe');
		$objs.each(function(){
			var $obj = $(this);
			$obj.attr('data-aspectRatio', this.height / this.width).removeAttr('height').removeAttr('width');
		});
	});
	
	$(window).resize(function() {
		$fluidElements.each(function(){
			var $figure   = $(this);
			var new_width = $figure.width();
			var $objs     = $figure.find('iframe[src^="http://player.vimeo.com"], iframe[src^="http://www.youtube.com"], object, embed, iframe');
			$objs.each(function(){
				var $obj = $(this);
				$obj.width(new_width).height(new_width * $obj.attr('data-aspectRatio'));
			});
		});
	}).resize();
});


/* ================================================== */
/* DOCUMENT READY
/* ================================================== */

$(document).ready(function() {

	/* ================================================== */
	/* LAUNCH FUNCTIONS
	/* ================================================== */

	checkIos();
	checkSessionStorageSupport();


	/* ================================================== */
	/* FASTCLICK
	/* ================================================== */

	$(function() {
		FastClick.attach(document.body);
	});


	/* ================================================== */
	/* PAGE TRANSITION
	/* ================================================== */

	$('#layout--header a').each(function(linkIndex, link) {
		$(link).click(function(event) {
			event.preventDefault();

			// Fade out menu links
			$('.fade--in').each(function(containerIndex, container) {
				$(container).removeClass('fade--in').addClass('fade--out');
			});

			// Fade out header brand if clicked
			if ($(link).hasClass('logo--brand')) {
				$('.logo--brand').addClass('fade--out')
			}

			// Redirect after transition
			setTimeout(function() {
				window.location.href = $(link).attr('href');
			}, 1000);
		});
	});


	/* ================================================== */
	/* ISOTOPE
	/* ================================================== */

	// Selector
	var isotope = $('.isotope');

	// Retreive sessionStorage value
	if (sessionStorageSupport == true && sessionStorage.getItem('filterSavedValue') !== null) {
		var filterSavedValue = sessionStorage.getItem('filterSavedValue');
		$(isotope).find('.dropdown-menu .is-checked').removeClass('is-checked');
		$(isotope).find('.dropdown-menu li a').each(function(index, element){
			if ($(element).data('filter') == filterSavedValue) {
				$(element).parent('li').addClass('is-checked');
				return false;
			}
		});
	} else {
		var filterSavedValue = '*';
	}

	// Clear session Storage when browsing to another section
	$('#layout--header a').click(function(){
		sessionStorage.removeItem('filterSavedValue');
	});

	// Init
	var grid = $(isotope).find('.isotope__wrapper').isotope({
		itemSelector : '.isotope__item',
		layoutMode   : 'fitRows',
		filter       : filterSavedValue
	});

	// Filter on click
	$(isotope).find('.dropdown-menu li').click(function() {
		var filterValue = $('a', this).attr('data-filter');
		grid.isotope({ filter: filterValue });
		$('.dropdown-menu').find('.is-checked').removeClass('is-checked');
		$(this).addClass('is-checked');

		if (sessionStorageSupport == true) {
			sessionStorage.setItem('filterSavedValue', filterValue);
		}
	});


	/* ================================================== */
	/* NEWS LIST BACK URL
	/* ================================================== */

	if ($('.module--webpage--news').length !== 0 && sessionStorageSupport == true && sessionStorage.getItem('newsPaginationState') !== null) {
		$('.icon--back').attr('href', sessionStorage.getItem('newsPaginationState'));
	}

	if (sessionStorageSupport == true) {
		$('.module--news .thumbnail--news header a, .module--news .target--details').click(function(event) {
			event.preventDefault;
			sessionStorage.setItem('newsPaginationState',window.location.href);
			window.location.href = $(this).attr('href');
		});
	}


	/* ================================================== */
	/* MASONRY
	/* ================================================== */

	// init Masonry after all images have loaded
	var $grid = $('.masonry').imagesLoaded(function() {
		$grid.masonry({
			itemSelector       : '.masonry__item',
			columnWidth        : '.masonry__sizer',
			percentPosition    : true
		});
	});


	/* ================================================== */
	/* FANCYBOX
	/* ================================================== */

	if ($('body').hasClass('device--ios')) {
		lockedValue = false;
	} else {
		lockedValue = true;
	}

	$('.fancybox').fancybox({
		maxWidth	: 1140,
		maxHeight	: 1140,
		fitToView	: true,
		width		: '70%',
		height		: '70%',
		margin      : [60, 30, 60, 30],
		padding     : 0,
		aspectRatio : true,
		closeClick	: true,
		showEarly   : false,
		locked      : lockedValue,
		openEffect	: 'fade',
		closeEffect	: 'none'
	});

	if (breakpoint_xs) {
		$('.fancybox').removeAttr('href').removeClass('fancybox');
	}


	/* ================================================== */
	/* SCROLL TO
	/* ================================================== */

	$('a[data-scroll-to]').each(function(index, element) {
		$(element).click(function(event) {
			event.preventDefault();
			$('html, body').animate({ scrollTop: 0 }, 300);
		});
	});

	/* ================================================== */
	/* SCROLL TO
	/* ================================================== */

	$('.scroll--off').click(function(){
		$(this).removeClass('scroll--off');
	});


});
